import type { ReactNode } from "react";
import { writesAllowed, type Scope } from "./scope";
/** Historical-mode only. Permission rendering remains shell-owned (I-7). */
export function WriteGate({ scope, children }: { scope: Scope; children: ReactNode }) { return writesAllowed(scope) ? <>{children}</> : null; }
